import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "assets/js/smtp.js";
import { environment } from "environments/environment";
declare let Email: any;
@Component({
  selector: "app-fashion-contact",
  templateUrl: "./fashion-contact.component.html",
  styleUrls: ["./fashion-contact.component.css"],
})
export class FashionContactComponent implements OnInit {
  fashionContactForm: FormGroup;
  displayNotif: boolean = false;
  formIsSending: boolean = false;
  loading: boolean = true
  constructor(public router: Router, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.fashionContactForm = this.fb.group({
      fname: [""],
      lname: [""],
      position: [""],
      companyName: [""],
      email: [""],
      phoneNumber: [""],
      messages: [""],
    });
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }

  onSubmit(): void {
    this.formIsSending = true;
    (document.getElementById("submit") as HTMLButtonElement).disabled = true;
    Email.send({
      Host: environment.hostname,
      Username: environment.username,
      Password: environment.password,
      To: environment.adminemail,
      From: environment.adminemail,
      Subject: "Contact Us",
      Body:
        "<b>First Name:</b> " +
        this.fashionContactForm.controls.fname.value +
        "<br />" +
        "<b>Last Name:</b> " +
        this.fashionContactForm.controls.lname.value +
        "<br />" +
        "<b>Position:</b> " +
        this.fashionContactForm.controls.position.value +
        "<br />" +
        "<b>Company Name:</b> " +
        this.fashionContactForm.controls.companyName.value +
        "<br />" +
        "<b>Email Address:</b> " +
        this.fashionContactForm.controls.email.value +
        "<br />" +
        "<b>Phone Number:</b> " +
        this.fashionContactForm.controls.phoneNumber.value +
        "<br />" +
        "<b>Message:</b> " +
        this.fashionContactForm.controls.messages.value,
    }).then((message) => {
      this.updateNotif();
      this.formIsSending = false;
      (document.getElementById("submit") as HTMLButtonElement).disabled = false;
      this.fashionContactForm.reset();
      setTimeout(() => {
        this.updateNotif();
      }, 3000);
    });
  }

  updateNotif(): boolean {
    return (this.displayNotif = !this.displayNotif);
  }
}
